var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.637 6.84 2.866 1.426v2.373a.82.82 0 0 0 1.637 0V9.082L9.394 10.7v7.245l-7.757-3.93V6.838zm.968-1.347 7.599-3.85 2.342 1.243-7.358 3.893-2.583-1.286zm14.854 0-7.255 3.783-3.213-1.6 7.302-3.863 3.166 1.68zm.904 1.374v7.159l-7.332 3.891v-7.226l7.332-3.824zm.786-2.33-4.411-2.34a.753.753 0 0 0-.103-.056L10.94.18A1.6 1.6 0 0 0 9.49.168L.88 4.532A1.58 1.58 0 0 0 0 5.954v8.09c0 .606.336 1.151.878 1.422l8.617 4.366a1.595 1.595 0 0 0 1.45-.016l8.202-4.353c.526-.276.853-.816.853-1.409v-8.11c0-.593-.327-1.133-.851-1.407z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.9ac23749cdec8bc712e71e3eed3114bc.svg";
export { ForwardRef as ReactComponent };